import React from 'react';
import PropTypes from 'prop-types';
import { normalizePortalText } from 'utils/baochauTheme';
import './style.scss';

const ErrorMessage = ({ message, id, className }) => {
  return (
    <div id={id} className={['bw_form_error', className].filter(Boolean).join(' ')} role='alert' aria-live='polite'>
      <span>{typeof message === 'string' ? normalizePortalText(message) : message}</span>
    </div>
  );
};
ErrorMessage.propTypes = {
  message: PropTypes.node.isRequired,
  id: PropTypes.string,
  className: PropTypes.string,
};
export default ErrorMessage;
